<script>
import TwTransitionListContainer from '@/components/generic/tw-transition-list-container.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'TwCardWithBackdrop',
  components: { TwButton, TwCard, TwContainer, XMarkIcon },
  props: {
    backdropUrl: {
      type: String,
      required: false,
      default:null
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['close']
}
</script>

<template>

      <div class="h-100">
      <div class="w-full bg-cover bg-center bg-no-repeat fixed h-screen bg-overlay z-0" :style="`background-image: url('${backdropUrl}');`" />
        <div class="z-10 flex justify-center sm:p-6 relative z-1">
          <div class="w-full sm:max-w-lg">
            <div class="rounded-none sm:rounded-2xl bg-white shadow-sm relative p-6 md:p-8 min-h-screen sm:min-h-max">
            <tw-button v-if="showCloseButton" variant="link" class="absolute right-4 top-4" @click="$emit('close')">
              <XMarkIcon class="size-7" />
            </tw-button>
            <slot />
          </div>
        </div>
      </div>
    </div>
</template>

<style scoped>

</style>
